import { render, staticRenderFns } from "./SearchItemResult.vue?vue&type=template&id=4fc9f932&"
import script from "./SearchItemResult.vue?vue&type=script&lang=js&"
export * from "./SearchItemResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports